module.exports = __webpack_public_path__ + "static/img/44.7c5e8078.jpg";